import { createContext } from 'react';
import { IBlackcartContext } from '../types';

const initialBCContext: IBlackcartContext = {
  shopDomain: '',
  baseBlackcart: undefined,
  cart: {
    currency: '',
    items: []
  },
  clearCart: () => {},
  selectedCurrency: '',
  isInitializing: true,
  goToBlackcartCheckout: () => {},
  isTBYBQualifiedCart: () => false,
  isTBYBItem: () => false,
  cartViolations: () => null,
  setCart: () => null
};

export const BlackcartContext = createContext<IBlackcartContext>(initialBCContext);
